module.exports = __webpack_public_path__ + "static/media/wind-turbine.bea6b10c.svg";